<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save" >
        <v-row>
            <v-col cols="12" v-if="showCompanySelector">
                <v-select
                    prepend-icon="business"
                    v-model="form.companyId"
                    :items="companies"
                    item-text="razonSocial"
                    item-value="id"
                    :label="$t('admin.inviraUser.labels.company')"
                    :error="hasInputErrors('companyId')"
                    :error-messages="getInputErrors('companyId')"
                    color="secondary"
                    :rules="showCompanySelector ? required : []"
                    :disabled="disableCompanySelector"
                    :readonly="disableCompanySelector"
                ></v-select>
            </v-col>
           
            <v-col cols="12" sm="6">
                <v-text-field
                    prepend-icon="expand-all"
                    name="nombre"
                    v-model="form.nombre"
                    :label="$t('deposito.labels.nombre')"
                    :placeholder="$t('deposito.labels.nombre')"
                    :error="hasInputErrors('nombre')"
                    :error-messages="getInputErrors('nombre')"
                    color="secondary"
                    :rules="required"
                ></v-text-field>
            </v-col>
    
            <v-col cols="12" sm="6">
                <v-text-field
                    prepend-icon="map-marker"
                    name="direccion"
                    v-model="form.direccion"
                    :label="$t('deposito.labels.direccion')"
                    :placeholder="$t('deposito.labels.direccion')"
                    :error="hasInputErrors('direccion')"
                    :error-messages="getInputErrors('direccion')"
                    color="secondary"
                ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
                <v-textarea
                    prepend-icon="text-subject"
                    name="descripcion"
                    v-model="form.descripcion"
                    :label="$t('deposito.labels.descripcion')"
                    :placeholder="$t('deposito.labels.descripcion')"
                    :error="hasInputErrors('descripcion')"
                    :error-messages="getInputErrors('descripcion')"
                    color="secondary"
                    rows="3"
                ></v-textarea>
            </v-col>
    
        </v-row>
    </v-form>
</template>

<script>

    import {InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'
    import CompanyProvider from "../../../providers/CompanyProvider";
    
    export default {
        name: "DepositoForm",
        mixins: [InputErrorsByProps, RequiredRule],
        
        props:{
            value: {
                type: Object,
                required: true
            },
            showCompanySelector: {
                type: Boolean,
                default: false
            },
            disableCompanySelector: {
                type: Boolean,
                default: false
            }
        },
        computed: {
           form: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
        data(){
            return {
                companies: []
            }
        },
        created() {
            if (this.showCompanySelector) {
                this.loadCompanies()
            }
        },
        watch: {
            form: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            loadCompanies() {
                CompanyProvider.fetchCompanies()
                    .then(r => {
                        this.companies = r.data.companyFetch || []
                    })
                    .catch(err => console.error(err))
            },
            validate(){
              return this.$refs.form.validate()
            }
        }
    }
</script>

<style scoped>

</style>
